import { UserRole } from 'src/app/swagger-api';

export enum MapFilters {
  COVID = 'Covid',
  COMMUNITIES = 'Communities',
  PROJECTS = 'Projects',
  ORGANIZATIONS = 'Organizations',
  PEOPLE = 'Individuals',
}

export enum AggregatedItemTypes {
  AGGREGATION_PROJECT = 'AggregationProject',
  AGGREGATION_COMMUNITY = 'AggregationCommunity',
  AGGREGATION_ORGANIZATION = 'AggregationOrganization',
  AGGREGATION_DOCTOR = 'AggregationDoctor',
  AGGREGATION_MED_STAFF = 'AggregationMedStaff',
  AGGREGATION_PATIENT = 'AggregationPatient',
  AGGREGATION_RESEARCHER = 'AggregationResearcher',
}

export enum SocialInitiativeItemTypes {
  PROJECT = 'Project',
  COMMUNITY = 'Community',
}

export const MapMarker = {
  ...AggregatedItemTypes,
  ...SocialInitiativeItemTypes,
  ...UserRole,
  COVID: 'Covid',
};
export type MapMarkerTypes = typeof MapMarker;

export enum ProcessResponseStrategyTypes {
  COVID,
  AGGREGATED,
  NON_AGGREGATED,
  PEOPLE_NON_AGGREGATED,
}

export enum NestedBucketIndividualRole {
  PATIENT = 'Patient',
  DOCTOR = 'Doctor',
  MED_STAFF = 'MedStaff',
  RESEARCHER = 'Researcher',
}

export enum NestedBucketOrganizationType {
  FOUNDATION = 'Foundation',
  HOSPITAL = 'Hospital',
  INSTITUTE = 'Institute',
  RESEARCH_CENTER = 'Research_center',
  OTHER = 'Other',
}
